import { createSharedComposable, useWindowSize as useWindow } from '@vueuse/core'

export const useWindowSize = createSharedComposable(useWindow)
